"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItemType = void 0;
var InvoiceItemType;
(function (InvoiceItemType) {
    InvoiceItemType["SellerWire"] = "sellerWireConfirmation";
    InvoiceItemType["BuyerWire"] = "buyerWireConfirmation";
    InvoiceItemType["LineItem"] = "invoiceLineItems";
})(InvoiceItemType || (exports.InvoiceItemType = InvoiceItemType = {}));
